import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import axios from 'axios';
import api from '../../../../services/api';
import { getPermissions } from '../../../../services/auth';
import { useHistory } from 'react-router';

import { dataAtualFormatada } from '../../../../utils/functions';

import Render from './RegisterRender';
import { InputOutlined } from '@material-ui/icons';
import { encrypt } from '../../../../services/crypto';
import { dddTel } from '../../../../utils/functions';

const EMAIL_CONEXAO_OPTIONS = ['Smtp', 'SmtpComSsl', 'Exchange', 'AutenticacaoModerna'];

const normalizeEmailConexao = (value = EMAIL_CONEXAO_OPTIONS[0]) => {
  if (value === null || value === undefined) {
    return EMAIL_CONEXAO_OPTIONS[0];
  }

  if (typeof value === 'number') {
    return EMAIL_CONEXAO_OPTIONS[value] ?? EMAIL_CONEXAO_OPTIONS[0];
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();

    if (trimmed === '') {
      return EMAIL_CONEXAO_OPTIONS[0];
    }

    if (!EMAIL_CONEXAO_OPTIONS.includes(trimmed)) {
      const numeric = Number(trimmed);
      if (!Number.isNaN(numeric)) {
        return EMAIL_CONEXAO_OPTIONS[numeric] ?? EMAIL_CONEXAO_OPTIONS[0];
      }
    }

    return trimmed;
  }

  return EMAIL_CONEXAO_OPTIONS[0];
};

const serializeEmailConexao = (value) => normalizeEmailConexao(value);

function Register() {
  const history = useHistory();

  const [inputs, setInputs] = useState({
    bairro: '',
    cep: '',
    cnpj: '',
    complemento: '',
    condicao: 'Nenhum',
    contaCorrenteLimiteDiario: 0,
    contaCorrenteLimiteMensal: 0,
    custoCdi: 0,
    dataAberturaEmpresa: '',
    departamentoAntecipacao: '',
    emailAntecipacao: '',
    emailAssinaturaAlterado: true,
    emailAssinaturaBase64: '',
    emailAssinaturaLink: '',
    layoutEmailFechamentoMesId: 0,
    emailAuthentication: 'Desabilitado',
    emailExchange: 'Nao',
    emailHost: '',
    emailPassword: '',
    emailPort: 0,
    emailSecure: 'Desabilitado',
    emailUserName: '',
    emailConexao: normalizeEmailConexao(),
    emailClientId: '',
    emailObjectId: '',
    emailTenanId: '',
    emailClientSecret: '',
    emailRedirectUri: '',
    emailScopesUrl: '',
    emailOutlookDomain: '',
    emailAccessToken: '',
    emailAccessTokenValidate: null,
    emailRefreshToken: '',
    emailRefreshTokenValidate: null,
    estadoId: 0,
    layoutArquivoImportacaoId: 0,
    layoutArquivoExportacaoId: 0,
    layoutEmailAncoraId: 0,
    layoutEmailAntecipacaoAprovadaId: 0,
    layoutEmailAntecipacaoReprovadaId: 0,
    layoutEmailAntecipacaoVencidaId: 0,
    layoutEmailFornecedorId: 0,
    layoutEmailInteresseId: 0,
    linkDominoExterno: '',
    logotipoAlterado: true,
    logotipoImagemBase64: '',
    logotipoLink: '',
    logradouro: '',
    minimoDiasParaPagamento: 0,
    municipioId: 0,
    nomeFantasia: '',
    nomePastaArquivos: '',
    numero: 0,
    ordemTitulos: 'NumeroNotaFiscal',
    razaoSocial: '',
    status: 'Pendente',
    taxaPercentualMinimoAncora: 0,
    taxaPercentualMinimoCapittale: 0,
    taxaMediaMinimoMesRede: 0,
    processandoArquivo: 'Nao',
    emailAncoraAgrupado: 'Nao',
    segregadoPorLoja: 'Nao',
    apelido: '',
    ambiente: 'Desenvolvimento',
    horaLimiteAceiteProposta: '',
    controlaContaBancaria: 'Nao',
    controlaLoja: 'Nao',
    usarRazaoComCodigoInternoFornecedor: 'Nao',
    ftpHost: '',
    ftpPort: 0,
    ftpUserName: '',
    ftpPassword: '',
    ftpDirectory: '',
    ftpProtocolo: 'Ftp',
    ftpStatus: 'Inativo',
    aprovacaoAposHoraLimite: 'NaoPermitido',
    tipoLojaCodigo: 'Alfabetico',
    fechamentoMes: 'MesAnterior',
    questionarFornecedoresBoletosEmitidos: 'Sim',
    destinoPagamentoId: 0,
    valorMinimoParaQualificado: 0,
    valorMinimoParaNaoQualificado: 0,
    bancoFidcValorTarifaBancaria: 0,
    telefoneComercialNumero: '',
    horaLimiteAceitePropostaSegunda: '',
    horaLimiteAceitePropostaTerca: '',
    horaLimiteAceitePropostaQuarta: '',
    horaLimiteAceitePropostaQuinta: '',
    horaLimiteAceitePropostaSexta: '',
    obrigaDigitoAgencia: 'Nao',
    questionarFornecedoresAceitaAbatimentosDescontos: 'Nao',
    enviarArquivoExportacaoNaAprovacao: 'Nao',
    erp: '',
    tiposDadosBancarios: 'Todos',
    tipoResumoDiario: 'ApenasPagamentoDMais1',
    custoCdiAtualizacaoAutomatica: 'Nao',
    vencimentoTituloEmDMais: 0,
    telaDeOperacoesInformacoes: '',
    enviarEmailsDeInteresseAposProcessarArquivo: "Nao",
    enviarWhatsAppAposProcessarArquivo: "Nao",
    controlaCorporate: "Nao"
  });
  const [destinoOpcoes, setDestinoOpcoes] = useState([]);
  const [getLoading, setLoading] = useState(true);
  const [getErros, setErros] = useState([]);

  const [getEstados, setEstados] = useState([]);
  const [getMunicipios, setMunicipios] = useState([]);
  const [inputsBlocked, setInputsBlocked] = useState([]);

  const [getLayoutsEmailsAncoras, setLayoutsEmailsAncoras] = useState([]);
  const [getLayoutsEmailsInteresses, setLayoutsEmailsInteresses] = useState([]);
  const [getLayoutsEmailsAntecipacoes, setLayoutsEmailsAntecipacoes] = useState([]);
  const [getLayoutsEmailsAntecipacoesAprovadas, setLayoutsEmailsAntecipacoesAprovadas] = useState(
    [],
  );
  const [getLayoutsEmailsAntecipacoesReprovadas, setLayoutsEmailsAntecipacoesReprovadas] = useState(
    [],
  );
  const [getLayoutsEmailsAntecipacoesVencidas, setLayoutsEmailsAntecipacoesVencidas] = useState([]);
  const [getLayoutsArquivoTitulosImportação, setLayotsArquivoTitulosImportação] = useState([]);
  const [getLayoutsArquivoTituloExportação, setLayotsArquivoTitulosExportação] = useState([]);
  const [getLayoutsEmailsFechamentosMeses, setLayoutsEmailsFechamentosMeses] = useState([]);
  const [getLayoutsSlipRede, setLayoutsSlipRede] = useState([]);

  const handleInputChange = (event, value) => {
    event.persist();
    const { name } = event.target;
    let nextValue = value || event.target.value;

    if (name === 'emailConexao') {
      nextValue = normalizeEmailConexao(nextValue);
    }

    // Converter destinoPagamentoId para número
    if (name === 'destinoPagamentoId') {
      const numValue = nextValue ? Number(nextValue) : 0;
      console.log('🔍 destinoPagamentoId alterado:', { original: nextValue, converted: numValue });
      nextValue = numValue;
    }

    setInputs((inputs) => ({ ...inputs, [name]: nextValue }));

    if(event.target.name == 'custoCdiAtualizacaoAutomatica' && event.target.value == 1) {
      setInputs((inputs) => ({ ...inputs, custoCdi: 0}));
    }
  };

  const handleInputNumberChange = (event, value) => {
    inputs[event.target.name] = value || event.target.value;
    setInputs(inputs);
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const base64 = await convertBase64(file);
      setInputs((inputs) => ({ ...inputs, [event.target.name]: base64 }));
    }
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const getInfoForForm = async () => {
    try {
      const searchStates = await api.get('Estados/Consultar?status=Ativo');
      const findLayoutsEmailsAncoras = await api.get('LayoutsEmailsAncoras/Consultar?status=Ativo');
      const findLayoutsEmailsInteresses = await api.get(
        'LayoutsEmailsInteresses/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoes = await api.get(
        'LayoutsEmailsFornecedores/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoesAprovadas = await api.get(
        'LayoutsEmailsAntecipacoesAprovadas/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoesReprovadas = await api.get(
        'LayoutsEmailsAntecipacoesReprovadas/Consultar?status=Ativo',
      );
      const findLayoutsEmailsAntecipacoesVencidas = await api.get(
        'LayoutsEmailsAntecipacoesVencidas/Consultar?status=Ativo',
      );
      const findLayoutsArquivoTitulosImportação = await api.get(
        'LayoutsArquivosImportacoes/Consultar?status=Ativo',
      );
      const findLayoutsArquivoTitulosExportação = await api.get(
        'LayoutsArquivosExportacoes/Consultar?status=Ativo',
      );
      const findLayoutsEmailsFechamentosMeses = await api.get(
        'LayoutsEmailsFechamentosMeses/Consultar?status=Ativo',
      );
      const findLayoutsSlipRede = await api.get('LayoutsSlips/Consultar?status=Ativo');
      const destinos = await api.get('DestinosPagamentos/Consultar?status=Ativo')

      setEstados(searchStates.data.resposta);
      setLayoutsEmailsAncoras(findLayoutsEmailsAncoras.data.resposta);
      setLayoutsEmailsInteresses(findLayoutsEmailsInteresses.data.resposta);
      setLayoutsEmailsAntecipacoes(findLayoutsEmailsAntecipacoes.data.resposta);
      setLayoutsEmailsAntecipacoesAprovadas(findLayoutsEmailsAntecipacoesAprovadas.data.resposta);
      setLayoutsEmailsAntecipacoesReprovadas(findLayoutsEmailsAntecipacoesReprovadas.data.resposta);
      setLayoutsEmailsAntecipacoesVencidas(findLayoutsEmailsAntecipacoesVencidas.data.resposta);
      setLayotsArquivoTitulosImportação(findLayoutsArquivoTitulosImportação.data.resposta);
      setLayotsArquivoTitulosExportação(findLayoutsArquivoTitulosExportação.data.resposta);
      setLayoutsEmailsFechamentosMeses(findLayoutsEmailsFechamentosMeses.data.resposta);
      setLayoutsSlipRede(findLayoutsSlipRede.data.resposta);
      setDestinoOpcoes(destinos.data.resposta)
    } catch (err) {
      toast.error('Detectamos um problema interno! tente novamente em instantes.');
    }
    setLoading(false);
  };

  const getAllMunicipios = async () => {
    try {
      const searchCities = await api.get(
        `Municipios/ConsultarEstadoId?id=${inputs.estadoId}&status=Ativo`,
      );
      setMunicipios(searchCities.data.resposta);
      setInputs({ ...inputs, municipioId: inputs.municipioId });
    } catch (err) {
      toast.error('Falha ao consultar a lista de municípios');
    }
  };

  useEffect(() => {
    if (inputs.estadoId) {
      getAllMunicipios();
    }
  }, [inputs.estadoId]);

  useEffect(() => {
    const permissions = getPermissions({ moduloId: 711, permissao: 'Cadastrar' });

    if (permissions) {
      getInfoForForm();
    } else {
      history.push('/app');
    }
  }, []);

  /* const findInputAndReturnString = (inputName) => {
    return inputs[inputName] ? inputs[inputName] : ''
  } */

  const handleSubmit = async (event) => {
    if (event && event.type !== 'submit') {
      event.preventDefault();
      
      // Validação: CNPJ é obrigatório
      const cnpjLimpo = (inputs.cnpj || '').replace(/[^\d]/g, '');
      if (!cnpjLimpo || cnpjLimpo.length !== 14) {
        toast.error('CNPJ é obrigatório e deve ter 14 dígitos');
        setErros(['Cnpj']);
        return;
      }
      
      // Validação: pelo menos um dos campos (Razão Social ou Nome Fantasia) deve estar preenchido
      const razaoSocialTrimmed = (inputs.razaoSocial || '').trim();
      const nomeFantasiaTrimmed = (inputs.nomeFantasia || '').trim();
      
      if (!razaoSocialTrimmed && !nomeFantasiaTrimmed) {
        toast.error('É obrigatório preencher pelo menos um dos campos: Razão Social ou Nome Fantasia');
        const errosArray = [];
        if (!razaoSocialTrimmed) errosArray.push('RazaoSocial');
        if (!nomeFantasiaTrimmed) errosArray.push('NomeFantasia');
        setErros(errosArray);
        return;
      }
      
      // Validação: se preenchido, deve ter no mínimo 3 caracteres
      if (razaoSocialTrimmed && razaoSocialTrimmed.length < 3) {
        toast.error('Razão Social deve ter no mínimo 3 caracteres');
        setErros(['RazaoSocial']);
        return;
      }
      
      if (nomeFantasiaTrimmed && nomeFantasiaTrimmed.length < 3) {
        toast.error('Nome Fantasia deve ter no mínimo 3 caracteres');
        setErros(['NomeFantasia']);
        return;
      }
      
      setLoading(true);
      try {
        const newLogotipo = inputs.newLogotipoImagemBase64;
        const newAssinatura = inputs.newEmailAssinaturaBase64;

        delete inputs.newLogotipoImagemBase64;
        delete inputs.newEmailAssinaturaBase64;

        // Preparar payload
        const payload = {
          // informações
          cnpj: inputs.cnpj,
          status: inputs.status,
          razaoSocial: inputs.razaoSocial,
          nomeFantasia: inputs.nomeFantasia,
          apelido: inputs.apelido,
          departamentoAntecipacao: inputs.departamentoAntecipacao,
          linkDominioExterno: inputs.linkDominoExterno,
          dataAberturaEmpresa: inputs.dataAberturaEmpresa
            ? inputs.dataAberturaEmpresa && dataAtualFormatada(inputs.dataAberturaEmpresa)
            : null,
          // Financeiro
          custoCdi: inputs.custoCdi && parseFloat(inputs.custoCdi),
          minimoDiasParaPagamento:
            inputs.minimoDiasParaPagamento && parseInt(inputs.minimoDiasParaPagamento),
          taxaPercentualMinimoAncora:
            inputs.taxaPercentualMinimoAncora && parseFloat(inputs.taxaPercentualMinimoAncora),
          taxaPercentualMinimoCapittale:
            inputs.taxaPercentualMinimoCapittale &&
            parseFloat(inputs.taxaPercentualMinimoCapittale),
          taxaMediaMinimoMesRede:
            inputs.taxaMediaMinimoMesRede &&
            parseFloat(inputs.taxaMediaMinimoMesRede),
          contaCorrenteLimiteDiario:
            inputs.contaCorrenteLimiteDiario && parseFloat(inputs.contaCorrenteLimiteDiario),
          contaCorrenteLimiteMensal:
            inputs.contaCorrenteLimiteMensal && parseFloat(inputs.contaCorrenteLimiteMensal),
          fechamentoMes: inputs.fechamentoMes,
          // Importação de Arquivo de Titulo
          layoutArquivoImportacaoId:
            inputs.layoutArquivoImportacaoId && parseInt(inputs.layoutArquivoImportacaoId),
          processandoArquivo: inputs.processandoArquivo,
          nomePastaArquivos: inputs.nomePastaArquivos,
          controlaLoja: inputs.controlaLoja,
          tipoLojaCodigo: inputs.tipoLojaCodigo,
          // Exportação de propostas aprovadas
          layoutArquivoExportacaoId:
            inputs.layoutArquivoExportacaoId && parseInt(inputs.layoutArquivoExportacaoId),
          ftpStatus: inputs.ftpStatus,
          ftpHost: inputs.ftpHost,
          ftpName: inputs.ftpName,
          ftpProtocolo: inputs.ftpProtocolo,
          ftpPort: inputs.ftpPort && parseInt(inputs.ftpPort),
          ftpDirectory: inputs.ftpDirectory,
          // Informações de Email
          emailExchange: inputs.emailExchange,
          emailAuthentication: inputs.emailAuthentication,
          emailSecure: inputs.emailSecure,
          emailAntecipacao: inputs.emailAntecipacao,
          emailUserName: inputs.emailUserName,
          emailHost: inputs.emailHost,
          emailPort: inputs.emailPort && parseInt(inputs.emailPort),
          // Novos campos de email
          emailConexao: serializeEmailConexao(inputs.emailConexao),
          emailClientId: inputs.emailClientId || '',
          emailObjectId: inputs.emailObjectId || '',
          emailTenanId: inputs.emailTenanId || '',
          emailClientSecret: inputs.emailClientSecret || '',
          emailRedirectUri: inputs.emailRedirectUri || '',
          emailScopesUrl: inputs.emailScopesUrl || '',
          emailOutlookDomain: inputs.emailOutlookDomain || '',
          emailAccessToken: inputs.emailAccessToken || '',
          emailAccessTokenValidate: inputs.emailAccessTokenValidate || null,
          emailRefreshToken: inputs.emailRefreshToken || '',
          emailRefreshTokenValidate: inputs.emailRefreshTokenValidate || null,
          // Layouts Emails
          layoutEmailAncoraId: inputs.layoutEmailAncoraId && parseInt(inputs.layoutEmailAncoraId),
          layoutEmailFechamentoMesId:
            inputs.layoutEmailFechamentoMesId && parseInt(inputs.layoutEmailFechamentoMesId),
          layoutEmailFornecedorId:
            inputs.layoutEmailFornecedorId && parseInt(inputs.layoutEmailFornecedorId),
          layoutEmailInteresseId:
            inputs.layoutEmailInteresseId && parseInt(inputs.layoutEmailInteresseId),
          layoutEmailAntecipacaoAprovadaId:
            inputs.layoutEmailAntecipacaoAprovadaId &&
            parseInt(inputs.layoutEmailAntecipacaoAprovadaId),
          layoutEmailAntecipacaoReprovadaId:
            inputs.layoutEmailAntecipacaoReprovadaId &&
            parseInt(inputs.layoutEmailAntecipacaoReprovadaId),
          layoutEmailAntecipacaoVencidaId:
            inputs.layoutEmailAntecipacaoVencidaId &&
            parseInt(inputs.layoutEmailAntecipacaoVencidaId),
          // Slip Pagamentos
          ordemTitulos: inputs.ordemTitulos,
          condicao: inputs.condicao,
          controlaContaBancaria: inputs.controlaContaBancaria,
          emailAncoraAgrupado: inputs.emailAncoraAgrupado,
          segregadoPorLoja: inputs.segregadoPorLoja,
          usarRazaoComCodigoInternoFornecedor: inputs.usarRazaoComCodigoInternoFornecedor,
          // endereço
          cep: inputs.cep ? inputs.cep : '',
          estadoId: inputs.estadoId && parseInt(inputs.estadoId),
          municipioId: inputs.municipioId && parseInt(inputs.municipioId),
          numero: inputs.numero && parseInt(inputs.numero),
          // Aprovação de Proposta
          aprovacaoAposHoraLimite: inputs.aprovacaoAposHoraLimite,
          horaLimiteAceiteProposta: inputs.horaLimiteAceiteProposta,
          // config
          ambiente: inputs.ambiente,
          // Logotipo
          logotipoAlterado: !!newLogotipo,
          logotipoImagemBase64: newLogotipo && newLogotipo.split(',').pop(),
          // Ass
          emailAssinaturaAlterado: !!newAssinatura,
          emailAssinaturaBase64: newAssinatura && newAssinatura.split(',').pop(),
          valorMinimoParaQualificado:
            inputs.valorMinimoParaQualificado && parseFloat(inputs.valorMinimoParaQualificado),
          valorMinimoParaNaoQualificado:
            inputs.valorMinimoParaNaoQualificado && parseFloat(inputs.valorMinimoParaNaoQualificado),
          bancoFidcValorTarifaBancaria:
            inputs.bancoFidcValorTarifaBancaria && parseFloat(inputs.bancoFidcValorTarifaBancaria),
          telefoneComercialNumero:
            inputs.telefoneComercialNumero && dddTel(inputs.telefoneComercialNumero),
          telefoneComercialDDD: inputs.telefoneComercialNumero && dddTel(inputs.telefoneComercialNumero, 'ddd'),
          horaLimiteAceitePropostaSegunda: inputs.horaLimiteAceitePropostaSegunda,
          horaLimiteAceitePropostaTerca: inputs.horaLimiteAceitePropostaTerca,
          horaLimiteAceitePropostaQuarta: inputs.horaLimiteAceitePropostaQuarta,
          horaLimiteAceitePropostaQuinta: inputs.horaLimiteAceitePropostaQuinta,
          horaLimiteAceitePropostaSexta: inputs.horaLimiteAceitePropostaSexta,
          obrigaDigitoAgencia: inputs.obrigaDigitoAgencia,
          erp: inputs.erp,
          tiposDadosBancarios: inputs.tiposDadosBancarios,
          tipoResumoDiario: inputs.tipoResumoDiario,
          custoCdiAtualizacaoAutomatica: inputs.custoCdiAtualizacaoAutomatica,
          enviarEmailsDeInteresseAposProcessarArquivo: inputs.enviarEmailsDeInteresseAposProcessarArquivo,
          enviarWhatsAppAposProcessarArquivo: inputs.enviarWhatsAppAposProcessarArquivo,
          controlaCorporate: inputs.controlaCorporate,
          // Spread dos inputs restantes (deve vir por último para não sobrescrever as correções acima)
          ...inputs,
          // Garantir que campos críticos não sejam sobrescritos pelo spread
          dataAberturaEmpresa: inputs.dataAberturaEmpresa && inputs.dataAberturaEmpresa.trim() !== ''
            ? dataAtualFormatada(inputs.dataAberturaEmpresa)
            : null,
          destinoPagamentoId: (inputs.destinoPagamentoId !== undefined && inputs.destinoPagamentoId !== null && inputs.destinoPagamentoId !== '' && inputs.destinoPagamentoId !== '0')
            ? Number(inputs.destinoPagamentoId)
            : 0,
          vencimentoTituloEmDMais: inputs.vencimentoTituloEmDMais ? Number(inputs.vencimentoTituloEmDMais) : 0,
          ftpPassword: inputs.ftpPassword ? encrypt(inputs.ftpPassword) : (inputs.ftpPassword || ''),
          emailPassword: inputs.emailPassword ? encrypt(inputs.emailPassword) : (inputs.emailPassword || '')
        };

        // Log para debug
        console.log('📤 Payload enviado:', JSON.stringify(payload, null, 2));
        console.log('🔍 destinoPagamentoId no payload:', payload.destinoPagamentoId, 'tipo:', typeof payload.destinoPagamentoId);
        console.log('🔍 inputs.destinoPagamentoId:', inputs.destinoPagamentoId, 'tipo:', typeof inputs.destinoPagamentoId);

        const response = await api.post('Ancoras', payload);
        if (response.data.status !== 'Inconsistencia') {
          setInputs({});
          toast.success('Rede registrada com sucesso!');
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = [];

            response.data.resposta.map((resposta) => {
              errosArray.push(resposta.key);

              toast.error(resposta.key + ' - ' + resposta.message);
              return null;
            });
            setErros(errosArray);
          } else {
            toast.error('Não foi possível adicionar a nova rede!');
          }
        }
      } catch (err) {
        console.error('❌ Erro na requisição:', err);
        console.error('❌ Response data:', err.response?.data);
        
        if (err.response?.data) {
          // Se tiver resposta com detalhes de validação
          if (err.response.data.resposta && err.response.data.resposta.length > 0) {
            const errosArray = [];
            err.response.data.resposta.forEach((resposta) => {
              errosArray.push(resposta.key || 'Erro');
              const mensagem = resposta.key 
                ? `${resposta.key} - ${resposta.message || 'Erro de validação'}`
                : resposta.message || 'Erro de validação';
              toast.error(mensagem);
            });
            setErros(errosArray);
          } else if (err.response.data.resposta && err.response.data.resposta[0]) {
            toast.error(err.response.data.resposta[0].message);
          } else {
            toast.error('Erro ao processar a requisição. Verifique o console para mais detalhes.');
          }
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.');
        }
      }
      setLoading(false);
    } else if(event) {
      event.preventDefault();
    }
  };

  const findCep = async (cep) => {
    cep = cep.replace('-', '').replace('.', '');
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json`);
      const { logradouro, bairro, ibge } = response.data;

      if (logradouro.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'logradouro']);
      }
      if (bairro.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'bairro']);
      }

      if (ibge.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'estado', 'municipio']);
        const responseMunicipio = await api.get(`Municipios/ConsultarIBGEId?id=${ibge}`);
        const { estadoId, municipioId } = responseMunicipio.data.resposta[0];
        setInputs({ ...inputs, logradouro, bairro, estadoId, municipioId });

        const listFields = ['Cep', 'Logradouro', 'Bairro', 'EstadoId', 'MunicipioId'];

        setErros(
          getErros.filter(function (item) {
            return !listFields.includes(item);
          }),
        );
      } else {
        setInputs({ ...inputs, logradouro, bairro });
      }
    } catch (err) {
      setInputsBlocked([]);
    }
  };

  return (
    <Render
      inputs={inputs}
      getLoading={getLoading}
      handleInputChange={handleInputChange}
      handleFileChange={handleFileChange}
      getErros={getErros}
      setErros={setErros}
      findCep={findCep}
      inputsBlocked={inputsBlocked}
      getEstados={getEstados}
      getMunicipios={getMunicipios}
      getLayoutsEmailsAncoras={getLayoutsEmailsAncoras}
      getLayoutsEmailsInteresses={getLayoutsEmailsInteresses}
      getLayoutsEmailsAntecipacoes={getLayoutsEmailsAntecipacoes}
      getLayoutsEmailsAntecipacoesAprovadas={getLayoutsEmailsAntecipacoesAprovadas}
      getLayoutsEmailsAntecipacoesReprovadas={getLayoutsEmailsAntecipacoesReprovadas}
      getLayoutsEmailsAntecipacoesVencidas={getLayoutsEmailsAntecipacoesVencidas}
      getLayoutsArquivoTitulosImportação={getLayoutsArquivoTitulosImportação}
      getLayoutsArquivoTituloExportação={getLayoutsArquivoTituloExportação}
      getLayoutsEmailsFechamentosMeses={getLayoutsEmailsFechamentosMeses}
      getLayoutsSlipRede={getLayoutsSlipRede}
      onSubmit={handleSubmit}
      destinoOpcoes={destinoOpcoes}
      handleInputNumberChange={handleInputNumberChange}
    />
  );
}

export default Register;
